import React from "react";
import BundleOptionSelect from "./BundleOptionSelect";
import BundleOptionCheckbox from "./BundleOptionCheckbox";
import BundleOptionRadio from "./BundleOptionRadio";

const BundleOption = ({ option, selectedValue }) => {
  let selectedBundledProduct = option.values.find(
    ({ value }) => value === selectedValue?.values[0]
  );

  if (
    !selectedBundledProduct &&
    option.required &&
    option.values.length === 1
  ) {
    selectedBundledProduct = option.values[0];
  }

  if (option.type === "checkbox") {
    return (
      <BundleOptionCheckbox
        option={option}
        selectedValues={selectedValue?.values}
      />
    );
  } else if (option.type === "radio") {
    return (
      <BundleOptionRadio
        option={option}
        selectedBundledProduct={selectedBundledProduct}
      />
    );
  } else if (option.type === "select") {
    return (
      <BundleOptionSelect
        option={option}
        selectedBundledProduct={selectedBundledProduct}
        initialQuantity={selectedValue?.quantity}
      />
    );
  } else {
    console.warn("This option type for bundle products is not supported yet.");
    if (option.required) {
      throw new Error("This product can't be ordered yet.");
    }
    return null;
  }
};
export default BundleOption;
